export class Threshold {
    Id!: number;
    Threshold_Amount!: number;
    CurrencyCode!: string;
    FromDate!: Date;
    FromDateFormatted ? :string
    ToDate? : Date;
    ToDateFormatted ?:string;
    UpdatedBy ? :string;
    UpdatedDate ? :Date;
}